/*
*###############################################################################
*Module Name                   : DPSearchBoxDynamic.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*
* NOTE: This component implements debounced search functionality using lodash.debounce
* to improve performance by preventing excessive API calls while typing.
* The search is triggered 1000ms after the user stops typing.
*/
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal, Spinner, Input, InputGroup, InputGroupText, Table, FormGroup, Label } from "reactstrap"
import "../../assets/scss/datatables.scss"
import ReactPaginate from 'react-paginate';
import "../../assets/scss/searchtable.scss"
import { loadPopupSearchPay } from "framework/validators/SearchColumn";
import Noimage from "../../assets/images/product/noimage.jpg"
import { SearchContainer } from './styles/SearchBox.styles';
import { debounce } from 'lodash';

const DPSearchBoxDynamic = (props) => {

    const [searchPlaceholder, setSearchPlaceholder] = useState(`Search By ${props.columns.length > 0 ? props.columns[0].title : 'Code'}`)
    const [searchBy, setSearchBy] = useState(props.searchBy) //filter code ex: CM_CODE
    const [columns, setColumns] = useState([]) //columns for table
    const [page, setPage] = useState(0) //current page
    const [pageSize, setPageSize] = useState(10) //page size
    const [count, setCount] = useState(0) //total row count
    const [data, setData] = useState([]) //data for table
    const [isLoaded, setIsLoaded] = useState(false)
    const [searchString, setSearchString] = useState("0") //user entered search string
    const [isDataLoaded, setIsDataLoaded] = useState(false)
    const [isDebouncing, setIsDebouncing] = useState(false) // New state to track debounced search status
    const tableRef = useRef(null);
    const [orderBy, setOrderBy] = useState("ASC")//order by ASC or DESC
    const [OrderByString, setOrderByString] = useState(props.columns.length > 0 ? props.columns[0].title : 'Code')
    const [selectedRow, setSelectedRow] = useState(0); //highlight selected row , selected row index
    const [selectedColumn, setSelectedColumn] = useState(0); //selected column for search
    const searchref = useRef(null); //search input ref
    const [searchPlace, setSearchPlace] = useState(0)
    const [loading, setLoading] = useState(false)
    const [imageUrl, setImageUrl] = useState("")
    useEffect(() => {
        const initializeSearch = async () => {
            try {
                setSearchBy(props.searchBy);
                setSearchPlaceholder(`Search By ${props.columns.length > 0 ? props.columns[0].title : 'Code'}`);
                setPage(0);
                setPageSize(10);
                setSelectedColumn(0);
                setCount(0);
                setLoading(false);
                setOrderBy(props.orderBy || "ASC");

                if (props.isOpen) {
                    setIsLoaded(true);
                    const response = await loadPopupSearchPay(props.MenuCode, props.URLPath);
                    setColumns(response.arCusCol);

                    const searchByColumnName = response.arCusCol.find(col => col.field === response.searchBy);
                    if (searchByColumnName) {
                        setSearchPlaceholder(`Search By ${searchByColumnName.title}`);
                        setSearchBy(response.searchBy);
                    }

                    await getData();
                } else {
                    setIsLoaded(false);
                    setData([]);
                    setSelectedRow(0);
                }
                setSearchString("0");
            } catch (error) {
                console.error('Error initializing search:', error);
                setLoading(false);
            }
        };

        initializeSearch();

    }, [props.isOpen])


    useEffect(async () => {
        if (isLoaded) {
            setOrderBy(props.orderBy ? props.orderBy : "ASC")
        }
    }, [isLoaded])

    useEffect(async () => {
        await getData();
    }, [page, pageSize, searchString, orderBy, searchBy]) // when page, page size, search string, order by, search by change get data from server


    async function getData() {

        if (props.MenuCode == undefined || props.MenuCode == null || props.MenuCode == "" || props.isOpen == false) return // if menu code is not set return from function
        const authToken = localStorage.getItem("authToken")
        setIsDataLoaded(true)

        var FilterString = props.FilterStr;
        setLoading(true)
        await fetch(`${props.APIURL}common/dsearch`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify({
                strMenuCode: props.MenuCode,
                strSearchControl: props.URLPath,
                strSearchKey: props.KeyVal,
                strSearchCol: searchBy == '' ? props.searchBy : searchBy,
                strSearchVal: searchString === "" ? "0" : searchString,
                intPageNo: page,
                intRowPerPage: parseInt(pageSize),
                strFilter: FilterString,
                orderBy: orderBy,
                searchPlace: parseInt(searchPlace)
            })
        }).then(async (Response) => await Response.json())
            .then(async (responseData) => {
                setLoading(false)
                if (responseData.success == true) {
                    var tabledata = responseData.data
                    var pagecount = responseData.count

                    setCount(pagecount)
                    setData(tabledata)

                } else {
                    setCount(0)
                    setData([])
                }
                setIsDataLoaded(false)
            }).catch((error) => {
                setLoading(false)
                setIsDataLoaded(false)
                setCount(0)
                setData([])
            })
    }

    const handlePageClick = (event) => {
        setPage(event.selected);
    };

    if (searchref.current) {
        searchref.current.focus()
    }    const handleKeyPress = (event) => { // key press event handling function 
        if (event.key === 'ArrowUp') { // if key is arrow up select previous row
            event.preventDefault();
            setSelectedRow((selectedRow) => Math.max(selectedRow - 1, 0));
        } else if (event.key === 'ArrowDown') { // if key is arrow down select next row
            event.preventDefault();
            setSelectedRow((selectedRow) => Math.min(selectedRow + 1, data.length - 1));
        } else if (event.key === 'Enter') { // if key is enter call select function
            if (data.length == 0) return
            props.getSelect(event, data[selectedRow])
        } else if (event.key === 'ArrowRight') { // if key is arrow right select next page
            // Check if we can go to the next page
            const maxPage = Math.ceil(count / pageSize) - 1;
            if (page < maxPage) {
                setPage(page + 1);
                setSelectedRow(0); // set selected row to 0 when page changes
            }
        } else if (event.key === 'ArrowLeft') { // if key is arrow left select previous page
            // Check if we can go to the previous page
            if (page > 0) {
                setPage(page - 1);
                setSelectedRow(0); // set selected row to 0 when page changes
            }
        }

        if (event.ctrlKey && event.key == 'x') {
            // add your code to handle the Control + X key event here
            setSearchPlace(searchPlace == 0 ? 1 : 0)
        }

    };


    const handleOptionChange = (event) => {
        setSearchPlace(event.target.value);
    };
    useEffect(() => {
        const selectedRowData = data[selectedRow]

        if (selectedRowData && selectedRowData?.PLU_PICTURE) {
            setImageUrl(`${window.Links.MediaServer + localStorage.getItem("Serial")}/images/product/${selectedRowData?.PLU_PICTURE}`)
        } else {
            setImageUrl("")
        }

    }, [selectedRow])
    
    const debouncedSearch = useCallback(
        debounce((value) => {
            setSearchString(value);
            setPage(0);
            setIsDebouncing(false); // Search is complete, turn off debouncing indicator
        }, 1000),
        []
    );

    const handleSearch = useCallback((e) => {
        const sanitizedInput = e.target.value.replace(/['"]/g, '');
        setIsDebouncing(true); // Show that search is in debounce mode
        debouncedSearch(sanitizedInput);
    }, [debouncedSearch]);

    const handleColumnClick = useCallback((index, column) => {
        setPage(0);
        setSearchBy(column.field);
        setSearchPlaceholder(`Search By ${column.title}`);
        setOrderByString(column.title);
        setSearchString("0");

        const element = document.getElementById("SearchBarDynamic");
        if (element) {
            element.focus();
        }

        setSelectedColumn(prev => {
            const newOrderBy = prev === index && orderBy === "ASC" ? "DESC" : "ASC";
            setOrderBy(newOrderBy);
            return index;
        });
    }, [orderBy]);

    return (
        <SearchContainer>
            <div onKeyDown={handleKeyPress}>
                <Modal
                    id="dynamicSearchModal"
                    size="xl"
                    isOpen={props.isOpen}
                    toggle={props.toggle}
                    centered
                    className="search-modal"
                >
                    <div className="modal-header">
                        <h5 className="modal-title">{props.mainTitle}</h5>
                        <button
                            onClick={props.toggle}
                            type="button"
                            className="close"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body p-4">
                        <Card>
                            <CardBody>
                                {props.SubTitle && (
                                    <CardTitle tag="h5" className="mb-4">{props.SubTitle}</CardTitle>
                                )}

                                <div className="search-controls mb-4">
                                    <Row className="align-items-center">
                                        <Col md={7}>
                                            <div className="d-flex">
                                                <FormGroup check inline>
                                                    <Input
                                                        type="radio"
                                                        id="searchMiddle"
                                                        name="searchType"
                                                        checked={searchPlace === 0}
                                                        onChange={() => setSearchPlace(0)}
                                                    />
                                                    <Label check for="searchMiddle">
                                                        Search by Middle Letter
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check inline>
                                                    <Input
                                                        type="radio"
                                                        id="searchFirst"
                                                        name="searchType"
                                                        checked={searchPlace === 1}
                                                        onChange={() => setSearchPlace(1)}
                                                    />
                                                    <Label check for="searchFirst">
                                                        Search by First Letter
                                                    </Label>
                                                </FormGroup>
                                            </div>
                                        </Col>
                                        <Col md={5}>                                            <InputGroup>
                                                <InputGroupText>
                                                    {isDebouncing ? (
                                                        <i className="fas fa-spinner fa-spin text-primary" title="Search in progress..."></i>
                                                    ) : (
                                                        <i className="fas fa-search"></i>
                                                    )}
                                                </InputGroupText>
                                                <Input
                                                    innerRef={searchref}
                                                    id="SearchBarDynamic"
                                                    type="text"
                                                    placeholder={isDebouncing ? "Search in progress..." : searchPlaceholder}
                                                    onChange={handleSearch}
                                                    size={"sm"}
                                                />
                                            </InputGroup>
                                            <div className="mt-1">
                                                <small className="text-muted">
                                                    <i className="fas fa-info-circle me-1"></i>
                                                    Search starts automatically after you stop typing
                                                </small>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <Row>
                                    <Col md={props?.showImage ? 10 : 12}>
                                        <div className="table-responsive">
                                            <Table bordered size="sm" className="mb-0 table-hover" style={{ backgroundColor: "#ffffff" }}>
                                                <thead style={{ backgroundColor: "#ffffff" }}>
                                                    <tr>
                                                        <th className="text-center" style={{ width: "60px" }}>#</th>
                                                        {columns.map((column, index) => (
                                                            <th
                                                                key={index}
                                                                onClick={() => handleColumnClick(index, column)}
                                                                style={{ textAlign: column.align, cursor: 'pointer' }}
                                                            >
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <span>{column.title}</span>
                                                                    {selectedColumn === index && (
                                                                        <i className={`fas fa-sort-${orderBy.toLowerCase()}`}></i>
                                                                    )}
                                                                </div>
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody style={{ backgroundColor: "#ffffff" }}>
                                                    {loading ? (
                                                        <tr>
                                                            <td colSpan={columns.length + 1} className="text-center">
                                                                <Spinner color="primary" size="sm" className="me-2" />
                                                                Loading...
                                                            </td>
                                                        </tr>
                                                    ) : data.length > 0 ? (data.map((row, index) => (<tr
                                                        key={index}
                                                        className={index === selectedRow ? 'fw-bold' : ''}
                                                        onClick={() => props.getSelect(null, row)}
                                                        style={{ cursor: 'pointer', backgroundColor: "#ffffff" }}
                                                    >
                                                        <td className="text-center" style={{ backgroundColor: "#ffffff" }}>
                                                            {page * pageSize + index + 1}
                                                        </td>
                                                        {columns.map((column, colIndex) => (
                                                            <td key={colIndex} style={{ textAlign: column.align, backgroundColor: "#ffffff" }}>
                                                                {row[column.field]}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                    ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={columns.length + 1} className="text-center">
                                                                <div className="text-muted">
                                                                    <i className="fas fa-search me-2"></i>
                                                                    No data found
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Col>

                                    {props?.showImage && (
                                        <Col md={2} className="d-flex align-items-center justify-content-center">
                                            <div className="image-preview text-center">
                                                <img
                                                    src={imageUrl || Noimage}
                                                    alt="Product"
                                                    className="img-fluid"
                                                    style={{ maxHeight: "300px", maxWidth: "100%" }}
                                                />
                                            </div>
                                        </Col>
                                    )}
                                </Row>

                                <div className="d-flex justify-content-between align-items-center mt-4">
                                    <div className="d-flex align-items-center">
                                        <span className="me-2">Page Size:</span>
                                        <Input
                                            type="select"
                                            bsSize="sm"
                                            style={{ width: "80px" }}
                                            value={pageSize}
                                            onChange={e => setPageSize(Number(e.target.value))}
                                        >
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </Input>
                                        <span className="ms-4">
                                            Total Records: {count}
                                        </span>
                                    </div>                                    <ReactPaginate
                                        previousLabel={<i className="fas fa-chevron-left" />}
                                        nextLabel={<i className="fas fa-chevron-right" />}
                                        breakLabel="..."
                                        pageCount={Math.ceil(count / pageSize)}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        forcePage={page}
                                        containerClassName="pagination pagination-sm mb-0"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        activeClassName="active"
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </Modal>
            </div>
        </SearchContainer>
    );
}

export default DPSearchBoxDynamic;
